__webpack_require__.p = "https://d3p12cfhe1hrbz.cloudfront.net/webinar-chat/";